import { useLocation } from "@reach/router";

export const useQuerySearch = (): string | undefined => {
  const { search } = useLocation();
  return search;
};

const useQueryParams = <T extends string>(keys: T[]): Map<T, string | null> => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const queryParams = new Map(keys.map((key) => [key, query.get(key)]));
  return queryParams;
};

export default useQueryParams;
